import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  useEffect(() => {
    document.body.classList.add('page-auth');
    return () => document.body.classList.remove('page-auth');
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center gap-2">
            <img src="/images/logo.png" alt="LeadNova" className="h-9 w-auto object-contain" />
            <span className="text-xl font-bold text-foreground">LeadNova</span>
            <span className="rounded bg-muted px-1.5 py-0.5 text-xs font-medium text-muted-foreground">
              Admin
            </span>
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
